import { atom } from "recoil";

const presetsLinkAtom = atom({
  key: "presetsLinkState",
  default: false,
});

export default presetsLinkAtom;
